import React from "react"
import { NavLink } from "react-router-dom"

const STYLES = {
  link: "flex items-center px-4 py-2 font-light no-underline rounded-md",
  externalLink: "flex items-center px-4 py-2 font-light text-black no-underline rounded-md hover:bg-gray-100",
  active: "bg-blue-100 text-blue-800",
  inactive: "text-black hover:bg-gray-100",
} as const

export interface SidebarItemProps {
  to: string
  children: React.ReactNode
  linkTo: (path: string) => string
  external?: boolean
  icon?: React.ReactNode
  "data-testid"?: string
}

export const SidebarItem: React.FC<SidebarItemProps> = ({
  to,
  children,
  linkTo,
  external,
  icon,
  "data-testid": testId,
}) => {
  if (external) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" className={STYLES.externalLink} data-testid={testId}>
        {children}
        {icon}
      </a>
    )
  }

  return (
    <NavLink
      to={linkTo(to)}
      className={({ isActive }) => `${STYLES.link} ${isActive ? STYLES.active : STYLES.inactive}`}
      data-testid={testId}
    >
      {children}
      {icon}
    </NavLink>
  )
}
